angular.module('forms').directive('apFormAnswerDate',
    ['$rootScope',
        function () {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/forms/views/directives/apFormAnswerDate.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    question: '=question',
                    answer: '=answer',
                    lastQuestion: '@lastQuestion'
                },
                controller: function($scope) {

                    $scope.datePopup = {
                        Opened: false
                    };

                    $scope.minDate = moment().subtract(100, 'year');
                    $scope.maxDate = moment().add(5, 'year');

                    $scope.openDatePicker = function openDatePicker($event) {
                        $event.preventDefault();
                        $scope.datePopup.Opened = true;
                    };

                    function loadView() {
                        $scope.question.SelectedAnswerId = $scope.answer.SurveyAnswerId;
                    }
                    loadView();
                }
            };
        }
    ]
);